module.exports = __webpack_public_path__ + "static/img/happy-redo.dfac3a1.svg";


//////////////////
// WEBPACK FOOTER
// ./static/img/hellocode-v2/happy-redo.svg
// module id = JpfB
// module chunks = 4